import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'material-ui/Icon';

const ZoomControl = ({ handleInClick, handleOutClick, handleFitClick }) => {
  const output = {};
  if (handleInClick) {
    output.zoomin = (
        <div className="tooltip">
            <Icon color="action" onClick={handleInClick}>zoom_in</Icon>
            <span className="tooltiptext">Zoom In</span>
        </div>
    );
  }

  if (handleOutClick) {
    output.zoomout = (
        <div className="tooltip">
            <Icon color="action" onClick={handleOutClick}>zoom_out</Icon>
            <span className="tooltiptext">Zoom Out</span>
        </div>
    );
  }

  if (handleFitClick) {
    output.zoomfit = (
        <div className="tooltip">
            <Icon color="action" onClick={handleFitClick}>fullscreen_exit</Icon>
            <span className="tooltiptext">Zoom Fit</span>
        </div>
    );
  }

  return (
    <div className="zoom-control">
        {output.zoomin}
        {output.zoomout}
        {output.zoomfit}
    </div>
  );
};

ZoomControl.propTypes = {
    handleInClick: PropTypes.func,
    handleOutClick: PropTypes.func,
    handleFitClick: PropTypes.func,
};

export default ZoomControl;



// WEBPACK FOOTER //
// ./scripts/components/ZoomControl.jsx